export const VISTA_CONSOLIDADO = 'consolidado';

export const EMPTY_FLUJO = {
  ventasTotal: 0,
  ventasCobradas: 0,
  ventasImpagas: 0,
  egresosTotal: 0,
  flujoCaja: 0,
};

export function displayCurrency(vista) {
  return vista === VISTA_CONSOLIDADO ? 'ARS' : vista;
}

export function pickFlujo(data, vista) {
  if (!data) return EMPTY_FLUJO;
  if (vista === VISTA_CONSOLIDADO) return data.enArs || data;
  return data.porMoneda?.[vista] || EMPTY_FLUJO;
}

export function vistaHint(vista) {
  if (vista === VISTA_CONSOLIDADO) {
    return 'Dólares y euros convertidos a pesos con el tipo de cambio de cada registro';
  }
  if (vista === 'ARS') return 'Solo movimientos registrados en pesos';
  if (vista === 'USD') return 'Solo movimientos registrados en dólares';
  if (vista === 'EUR') return 'Solo movimientos registrados en euros';
  return '';
}

export function mergeMonedas(...lists) {
  const set = new Set();
  lists.flat().forEach((m) => {
    if (m) set.add(String(m).toUpperCase());
  });
  return [...set].sort();
}

export function shouldShowCurrencyToggle(monedas = []) {
  return monedas.some((m) => m && m !== 'ARS') || monedas.length > 1;
}

export function emptyPylView(currency = 'ARS') {
  return {
    currency,
    consolidado: currency === 'ARS',
    ingresos: 0,
    ingresosBruto: 0,
    cantidad: 0,
    costoVentas: 0,
    gastosOperativos: 0,
    impuestos: 0,
    utilidadBruta: 0,
    resultadoOperativo: 0,
    ventasCobradas: 0,
    ventasImpagas: 0,
    diferenciaDevengadoCobrado: 0,
    porCategoria: [],
    costoDetalle: [],
    opexDetalle: [],
    impuestosDetalle: [],
  };
}

export function pickPyl(pyl, vista) {
  if (!pyl) return emptyPylView();

  if (vista === VISTA_CONSOLIDADO) {
    const src = pyl.enArs;
    if (src) {
      return { currency: 'ARS', consolidado: true, ...src };
    }
    return {
      ...emptyPylView('ARS'),
      consolidado: !!pyl.equivalenteArs?.disponible,
      ingresos: pyl.equivalenteArs?.ingresos ?? pyl.ingresos?.total ?? 0,
      costoVentas: pyl.costoVentas?.total ?? 0,
      gastosOperativos: pyl.gastosOperativos?.total ?? 0,
      impuestos: pyl.impuestos?.total ?? 0,
      utilidadBruta: pyl.equivalenteArs?.utilidadBruta ?? pyl.utilidadBruta ?? 0,
      resultadoOperativo: pyl.equivalenteArs?.resultadoOperativo ?? pyl.resultadoOperativo ?? 0,
      ventasCobradas: pyl.comparacionCaja?.ventasCobradas ?? 0,
      ventasImpagas: pyl.comparacionCaja?.ventasImpagas ?? 0,
      diferenciaDevengadoCobrado: pyl.comparacionCaja?.diferenciaDevengadoCobrado ?? 0,
      cantidad: pyl.ingresos?.cantidad ?? 0,
      porCategoria: pyl.ingresos?.porCategoria || [],
      costoDetalle: pyl.costoVentas?.detalle || [],
      opexDetalle: pyl.gastosOperativos?.detalle || [],
      impuestosDetalle: pyl.impuestos?.detalle || [],
    };
  }

  const src = pyl.porMoneda?.[vista];
  if (!src) return emptyPylView(vista);
  return { currency: vista, consolidado: false, ...src };
}

export function pickPylComparacion(comparacion, vista) {
  if (!comparacion) return null;
  if (vista === VISTA_CONSOLIDADO) {
    const src = comparacion.enArs || comparacion;
    return { ...comparacion, ...src };
  }
  const src = comparacion.porMoneda?.[vista];
  if (!src) {
    return {
      ...comparacion,
      ingresos: 0,
      resultadoOperativo: 0,
      variacionIngresos: 0,
      variacionResultado: 0,
    };
  }
  return { ...comparacion, ...src };
}
